export const NotRevalidateOption = {
  revalidateOnFocus: false,
  revalidateOnReconnect: false,
};
